module.exports = __webpack_public_path__ + "media/assets/icons/dox-coin-2c120dc1e9172c4da18e86481ac5a986.svg";